import {
    LIST_PRODUCT_COSTS,
    STORE_PRODUCT_COSTS
} from "../../constants/productCosts";

export const listProductCosts = () => ({
    type: LIST_PRODUCT_COSTS
})

export const storeProductCosts = (productCosts) => ({
    type: STORE_PRODUCT_COSTS,
    productCosts
})